module.exports = __webpack_public_path__ + "img/slide-17-1.ada82a8f.png";